import React from "react";
import { useNavigate } from "react-router-dom";
const DiaryDefault = () => {
  const waterandpoop = "/images/mo/waterandpoop.svg";
  const navigate = useNavigate();
  return (
    <>
      <div className="flex flex-col justify-center items-center pt-[119px]">
        <img src={waterandpoop} alt="waterandpoop" />
        <div className="pt-[20px]">아직 작성된 다이어리가 없어요!</div>
        <div className="pt-[16px]">건강다이어리를 작성하여</div>
        <div>장루를 보다 편히 관리해보세요:)</div>
      </div>
      <div className="mt-[48px] w-full px-[24px] ">
        <div
          className=" bg-[#1B5EDC] text-white button_700 py-[20px] text-center hover:bg-[#18428E] rounded-full cursor-pointer  ease-in-out duration-300"
          onClick={() => navigate("/healthdiary")}
        >
          다이어리 바로가기
        </div>
      </div>
    </>
  );
};

export default DiaryDefault;
